/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import './DateRangeField.scss'
import { compose } from 'ramda'
import React from 'react'
import ReactDatePicker from 'react-datepicker'

function DateRangeField(props) {
  const className = props.className || ''
  const dateFormat = props.dateFormat || 'yyyy/MM/dd'
  const todayButton = props.todayButton || '今日'
  const withPortal = props.withPortal || true
  const startDate = props.startDate || new Date()
  const endDate = props.endDate || new Date()
  const start = startDate
  const end = endDate
  const startSelected = props.startDate ? startDate : null
  const endSelected = props.endDate ? endDate : null

  const handleChange = name =>
    compose(date => {
      const dummyEvent = { target: { name: name, value: date } }
      props.onChange(dummyEvent)
    })

  const handleStartDateChange = handleChange(props.startDateName)
  const handleEndDateChange = handleChange(props.endDateName)

  return (
    <div className={`DateRangeField ${className}`}>
      <ReactDatePicker
        className="DateRangeField__datepicker"
        selectsStart={true}
        selected={startSelected}
        startDate={start}
        endDate={end}
        dateFormat={dateFormat}
        todayButton={todayButton}
        withPortal={withPortal}
        isClearable={true}
        onChange={handleStartDateChange}
      />
      <div className="DateRangeField__arrow">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
          <path
            fill="#0E141A"
            fillRule="evenodd"
            d="M15.513 11.222l-1.205-1.211-.501-.504L14.809 8.5l.501.504 1.966 1.974.01-.01 1.003 1.007-.501.503-2.507 2.518-.5.504-1.003-1.007.501-.504 1.206-1.211H6v-1.556h9.513z"
          />
        </svg>
      </div>
      <ReactDatePicker
        className="DateRangeField__datepicker"
        selectsEnd={true}
        selected={endSelected}
        startDate={start}
        endDate={end}
        dateFormat={dateFormat}
        todayButton={todayButton}
        withPortal={withPortal}
        isClearable={true}
        onChange={handleEndDateChange}
      />
    </div>
  )
}

export default DateRangeField
